<template>
  <div style="clear:both;">
    <v-card>
      <v-container fluid>
        <v-row dense>
          <v-col cols="12" sm="12">
            <v-textarea
              :label="$t('Closed_Voided_Reason')"
              name="reason"
              :model-value="closedVoidedReasonText"
              auto-grow
              variant="underlined"
              readonly
              dense
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" sm="7">
            <people-picker
              :label="$t('Closed_Voided_By')"
              readonly
              :user="closedVoidedUser"
              :inUser="closedVoidedUser"
            ></people-picker>
          </v-col>
          <v-col cols="12" sm="5">
            <v-text-field variant="underlined" :value="$filters.DateTimeFilter(closedVoidedDateValue)" readonly dense density="comfortable"></v-text-field>
          </v-col>
        </v-row>

        <v-row dense v-if="closedVoidUndo">
          <v-col cols="12" sm="12">
            <v-textarea
              :label="$t('Prompt_VoidUndoneWork')"
              variant="underlined"
              name="closedVoidUndo"
              :model-value="closedVoidUndoText"
              auto-grow
              rows="1"
              readonly
              dense
            ></v-textarea>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import PeoplePicker from '@/components/peoplePicker/PeoplePicker'
export default {
  data: () => ({}),
  props: {
    closedVoidedReason: {
      type: Object,
      default: null
    },
    mocFormStatus: {
      type: String
    },
    closedVoidUndo: {
      type: String,
      default: null
    }
  },
  components: {
    PeoplePicker
  },
  methods: {
    closedVoidedUserDisplayName: function(user) {
      return user ? user.displayName : ''
    }
  },
  computed: {
    readonly: function() {
      switch (this.mocFormStatus) {
        default:
          return true
      }
    },
    closedVoidedUser: function() {
      if (this.closedVoidedReason) {
        if (this.closedVoidedReason.closedVoidBy) {
          return this.closedVoidedReason.closedVoidBy
        }
      }
      return null
    },
    closedVoidedReasonText: function() {
      if (this.closedVoidedReason) {
        return this.closedVoidedReason.reason
      } else {
        return ''
      }
    },
    closedVoidedDateValue: function() {
      if (this.closedVoidedReason) {
        return this.closedVoidedReason.closedVoidDate
      } else {
        return null
      }
    },
    closedVoidUndoText: function() {
      if (this.closedVoidUndo) {
        return this.closedVoidUndo
      } else {
        return ''
      }
    }
  }
}
</script>

<style scoped></style>
